export const withComponent = (booleanOrComponent, DefaultComponent) =>
  booleanOrComponent === true
    ? DefaultComponent
    : booleanOrComponent === false
    ? null
    : booleanOrComponent;
